module.exports = __webpack_public_path__ + "static/media/Inter-Black.15c8274c.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-Black.woff2
// module id = 676
// module chunks = 21